<template>
  <div class="businesses-wrapper">
    <editor-placeholder v-once>
      <div class="intro">
        <h2>Le réseau d'agences Mobilize Share</h2>
        <p>
          Où que vous soyez, il y a toujours une agence de location Mobilize Share proche de chez vous. Aujourd'hui en France, le réseau Mobilize Share c'est <a
            :href="this.AGENCY_LIST_PDF"
            target="_blank"
          >plus de 500 agences de location de véhicules</a> à votre disposition dans plus de 340 villes.
        </p>
      </div>
    </editor-placeholder>
    <businesses-search
      v-if="showSearch"
      :preload="city || pickUpBusinessCityLabel"
      @cityselected="onCitySelected"
    />
    <div
      class="bottom"
      ref="element"
    >
      <div
        v-if="businesses.length"
        class="results"
      >
        <h2>{{ $t('pages.businesses.results') }} {{ selectedCity.label }} ({{ selectedCity.postal_code }})</h2>
        <div
          v-if="specificVehicle"
          class="subtitle"
          v-html="$t('pages.businesses.for_vehicle', {vehicle: this.specificVehicle.label, period: toFromDate})"
        />
        <div class="row">
          <businesses-results
            :specific-vehicle="specificVehicle"
            class="businesses-layout-block"
            :businesses="businesses"
          />
          <businesses-map
            class="businesses-layout-block"
            :businesses="businesses"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BusinessesLayout',
  components: {
    BusinessesSearch: () => import(/* webpackChunkName: "business"  */ `./BusinessesSearch`),
    BusinessesResults: () => import(/* webpackChunkName: "business"  */ `./BusinessesResults/BusinessesResults`),
    BusinessesMap: () => import(/* webpackChunkName: "business"  */ `../shared/map/BusinessesMap/BusinessesMap`),
    EditorPlaceholder: () => import(/* webpackChunkName: "business"  */ `../shared/EditorPlaceholder`),

  },
  data() {
    return {
      params: undefined,
      showSearch: false,
      vehicle: undefined,
      city: undefined,
      AGENCY_LIST_PDF: undefined,
    }
  },
  watch: {
    businessLocalStorageChecked: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return
        }

        this.showSearch = true
      },
    },
  },
  mounted() {
    this.$store.commit('businessSearch/SET_RESULTS_ELEMENT', this.$refs.element)
    this.$store.dispatch('vehicles/GET_VEHICLE_LIST')
    this.city = (this.searchParams.has('city') && this.searchParams.get('city'))
    this.vehicle = this.searchParams.has('vehicle') && this.searchParams.get('vehicle')
  },
  created() {
    this.AGENCY_LIST_PDF = window.renaultRent.settings.uri_agency_list
  },
  computed: {
    storeVehicle() {
      return this.$store.state.vehicles.set.storeVehicle
    },
    componentVehicle() {
      if (!this.vehicle && !this.storeVehicle) {
        return ''
      }

      if (this.vehicle) {
        return { slug: this.vehicle }
      }
      return this.storeVehicle
    },
    businesses() {
      return this.$store.state.businessSearch.businesses
    },
    businessLocalStorageChecked() {
      return this.$store.state.booking.businessLocalStorageChecked
    },
    pickUpBusinessCityLabel() {
      return this.$store.getters['booking/pickUpBusinessCityLabel']
    },
    selectedCity() {
      return this.$store.state.businessSearch.selectedCity
    },
    searchParams() {
      return new URLSearchParams(window.location.search)
    },
    vehicles() {
      return this.$store.state.vehicles.list.allVehicles
    },
    specificVehicle() {
      if (!this.componentVehicle || !this.vehicles.length) {
        return '';
      }
      return this.vehicles.find((car) => car.slug === this.componentVehicle.slug)
    },
    toFromDate() {
      return this.$store.getters['booking/formattedToFromDate']
    },
  },
  methods: {
    onCitySelected(data) {
      this.businesses = data.businesses
    },
  },
}
</script>
<style lang="scss" scoped>

.businesses-wrapper {
  margin: 20px 20px;
  width: calc(100vw - 40px);

  @include teq-breakpoint($large) {
    margin: 20px auto;
    max-width: calc(100% - 186px);
    width: calc(100vw - 20px);
  }
}

h1 {
  font-family: $f-graphie-bold;
  text-transform: lowercase;
}

.intro h2 {
  padding-top: 2.5rem;
}

.intro p {
  //color: $c-tundora;
  font-family: $f-graphie-book;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
}

.intro a {
  color: black;
  text-decoration: underline;
}

/*
h2 {
  //font-family: $f-graphie-lt;
  text-transform: uppercase;

  @include font-size(22px);
}
*/
.subtitle {
  @include font-size(18px);

  font-family: $f-graphie-lt;
  margin: 0 0 15px;
  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }
}

.subtitle ::v-deep span {
  text-transform: uppercase;
}

.row {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @include teq-breakpoint($large) {
    flex-direction: row;
  }
}

.businesses-layout-block {
  width: 100%;

  @include teq-breakpoint($large) {
    max-width: calc(50% - 20px);
  }
}

.bottom {
  margin: 20px 0 0;
}
</style>
